var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42708 2.01504e-06H20.5729C21.1544 -0.000560132 21.7304 0.116502 22.2677 0.34449C22.8051 0.572477 23.2934 0.906913 23.7046 1.32866C24.1158 1.7504 24.4418 2.25118 24.6641 2.80232C24.8864 3.35347 25.0005 3.94416 25 4.5406V20.4594C25.0005 21.0558 24.8864 21.6465 24.6641 22.1977C24.4418 22.7488 24.1158 23.2496 23.7046 23.6713C23.2934 24.0931 22.8051 24.4275 22.2677 24.6555C21.7304 24.8835 21.1544 25.0006 20.5729 25H4.42708C3.84556 25.0006 3.26963 24.8835 2.73227 24.6555C2.1949 24.4275 1.70664 24.0931 1.29544 23.6713C0.88424 23.2496 0.558165 22.7488 0.335877 22.1977C0.11359 21.6465 -0.000546129 21.0558 1.96466e-06 20.4594V4.5406C-0.000546129 3.94416 0.11359 3.35347 0.335877 2.80232C0.558165 2.25118 0.88424 1.7504 1.29544 1.32866C1.70664 0.906913 2.1949 0.572477 2.73227 0.34449C3.26963 0.116502 3.84556 -0.000560132 4.42708 2.01504e-06V2.01504e-06Z",
    fill: "#F8F7F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_148)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4641 5.73967L12.8289 5.26315L8.19375 5.73967L4.6053 10.4243L12.8289 19.7368L21.0526 10.4243L17.4641 5.73967Z",
    fill: "#FDB300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7216 10.4243L12.8289 19.7368L21.0526 10.4243H17.7216Z",
    fill: "#EA6C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93626 10.4243L12.8289 19.7368L4.6053 10.4243H7.93626Z",
    fill: "#EA6C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7216 10.4243H7.93626L12.8289 19.7368L17.7216 10.4243Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8289 5.26315L17.4642 5.73967L17.7216 10.4243L12.8289 5.26315Z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8289 5.26315L8.19375 5.73967L7.93626 10.4243L12.8289 5.26315Z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60525 10.4242L8.1938 5.73965L7.93626 10.4242H4.60525Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0526 10.4242L17.4642 5.73965L17.7216 10.4242H21.0526Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8289 5.26315L17.7216 10.4243H7.93626L12.8289 5.26315Z",
    fill: "#FEEEB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4474,
    height: 14.4737,
    fill: "white",
    transform: "matrix(-1 0 0 1 21.0526 5.26315)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/Sketch.7c418c3adab3f1d5726fac8467e83202.svg";
export { ForwardRef as ReactComponent };